import { useSelector } from 'react-redux';
import { notificationItemSelector } from 'reducers/notifications.reducer';
import { useSnackbar } from 'notistack';

type IOutput = {
  handleDismiss: () => void;
  variant: string;
};

export const useSnackMessageEvents = (id: string | number): IOutput => {
  const { variant } = useSelector(notificationItemSelector(id));
  const { closeSnackbar } = useSnackbar();
  const handleDismiss = (): void => {
    closeSnackbar(id);
  };

  return {
    variant,
    handleDismiss,
  };
};
